import baseStyles from '../Base/Base.styles'

export default ({ base, color }) => {
  return {
    root: {
      ...baseStyles(base),
      padding: '32px',
            
      color,

      '& .box': {
        padding: '24px',
        paddingTop: '32px',
        position: 'relative',
        border: `1px solid ${color}`,
        borderRadius: '8px'
      },

      '& .badge': {
        display: 'block',
        padding: '4px 24px',
        color: 'white',
        background: color,
        borderRadius: '8px',
        position: 'absolute',
        zIndex: 1,
        top: 0,
        left: '16px',
        transform: 'translateY(-50%)',
        fontStyle: 'italic'
      },

      '& .body': {
        fontWeight: 'normal',
        fontStyle: 'italic'
      }
    }
  }
}
